import { render, staticRenderFns } from "./InstanceAvatarImgError.vue?vue&type=template&id=7bd0af54&scoped=true"
import script from "./InstanceAvatarImgError.vue?vue&type=script&lang=js"
export * from "./InstanceAvatarImgError.vue?vue&type=script&lang=js"
import style0 from "./InstanceAvatarImgError.vue?vue&type=style&index=0&id=7bd0af54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd0af54",
  null
  
)

export default component.exports